// extracted by mini-css-extract-plugin
module.exports = {"title":"title--MSBRX","dashboardPage":"dashboardPage--tfQvj","dashboardLayout":"dashboardLayout--GcsqC","ant-row":"ant-row--5PTZu"};